import { skillToOption } from 'components/SkillsSelectInput/skillToOption';
import { useGQLQuery } from 'hooks/useGQLQuery';
import { QUERY_communitySkills } from 'queries';
import { useEffect, useMemo } from 'react';
import { CommunitySkillsQuery, CommunitySkillsQueryVariables } from 'types/graphql';

export function useCommunitySkills(locationId?: CommunitySkillsQueryVariables['locationId']) {
  const hasLocation = (locationId ?? 0) > 0;

  const { data, isLoading, fetch } = useGQLQuery<
    CommunitySkillsQuery,
    CommunitySkillsQuery,
    CommunitySkillsQueryVariables
  >({
    key: 'COMMUNITY_SKILLS',
    query: QUERY_communitySkills,
  });

  useEffect(() => {
    if (hasLocation) fetch({ variables: { locationId } });
  }, [locationId, hasLocation]); // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(() => {
    const skills = hasLocation
      ? data?.fetchCommunity?.communitiesSkills?.map(({ skill }) => skill) ?? []
      : [];
    return { skills, options: skills.map(skillToOption), isLoading: hasLocation && isLoading };
  }, [data, hasLocation, isLoading]);
}
